/**
 * "/terms" — public Terms of Use, reachable logged in or out.
 * Linked from the landing footer and the sign-up consent.
 */
import { createFileRoute } from '@tanstack/react-router';
import { TERMS_OF_USE } from '@finmin/ui';
import { LegalPage } from '@/features/legal/legal-page';

export const Route = createFileRoute('/terms')({
  component: () => <LegalPage doc={TERMS_OF_USE} />,
});
